import { getExamPeriodColor } from "../../utils/calendarColors.js";

export function examGradeLabel(grade) {
  return grade === "" || grade == null ? "미지정" : `${grade}학년`;
}

export function examSchoolColor(period) {
  if (!period.schoolChoiceId) return period.color;
  let hash = 0;
  for (const character of period.schoolChoiceId) {
    hash = (hash * 31 + character.charCodeAt(0)) >>> 0;
  }
  return getExamPeriodColor(hash % 12);
}

export function examPeriodsOnDate(periods, date) {
  return periods.filter((period) =>
    period.start && period.end && date >= period.start && date <= period.end
  )
    .toSorted((a, b) =>
      a.school.localeCompare(b.school, "ko") ||
      String(a.schoolChoiceId || a.id).localeCompare(
        String(b.schoolChoiceId || b.id),
      ) || Number(a.grade || 0) - Number(b.grade || 0) ||
      a.id.localeCompare(b.id)
    );
}

// Display aggregation only: keep original records and their subjects intact.
export function examCalendarRanges(periods) {
  const schools = new Map();
  for (const period of periods) {
    if (!period.start || !period.end) continue;
    const schoolKey = period.schoolChoiceId
      ? `school:${period.schoolChoiceId}`
      : `legacy:${period.id}`;
    if (!schools.has(schoolKey)) schools.set(schoolKey, new Map());
    const ranges = schools.get(schoolKey);
    const rangeKey = `${period.start}/${period.end}`;
    if (!ranges.has(rangeKey)) ranges.set(rangeKey, []);
    ranges.get(rangeKey).push(period);
  }
  const result = [];
  for (const [schoolKey, ranges] of schools) {
    for (const [rangeKey, originals] of ranges) {
      const members = [...originals].sort((a, b) =>
        Number(a.grade || 0) - Number(b.grade || 0) ||
        a.id.localeCompare(b.id)
      );
      const first = members[0];
      const grades = [
        ...new Set(members.map((item) => examGradeLabel(item.grade))),
      ];
      const showGrade = ranges.size > 1 || grades.length === 1;
      const compactGrades = grades.every((grade) => /^\d+학년$/.test(grade))
        ? `${grades.map((grade) => grade.replace("학년", "")).join(",")}학년`
        : grades.join(" / ");
      const label = showGrade
        ? `${first.school} · ${grades.join(" / ")}`
        : first.school;
      result.push({
        key: `${schoolKey}/${rangeKey}`,
        start: first.start,
        end: first.end,
        color: examSchoolColor(first),
        label,
        schoolLabel: first.school,
        gradeLabel: showGrade ? compactGrades : "",
        getLabel: (_, position) =>
          position === "start" || position === "single" ? label : "",
        getTitle: (date) =>
          [
            `${first.school} · ${first.start} ~ ${first.end}`,
            ...members.map((item) => {
              const value = item.subjects?.[date];
              const subject = typeof value === "string"
                ? value
                : value?.subject;
              const direct = typeof value === "object" ? value?.direct : "";
              return [
                examGradeLabel(item.grade),
                subject,
                direct ? `${direct} 직보` : "",
              ].filter(Boolean).join(" · ");
            }),
          ].join("\n"),
      });
    }
  }
  return result.sort((a, b) =>
    a.start.localeCompare(b.start) || a.key.localeCompare(b.key)
  );
}
